<template>
  <div class="hello">
    <div class="carousel-wrap center height">
      <div class="carousel-text">
        <!-- <h1>全国专业化、效率化、系统化酒店外包人力资源服务平台，值得你们的信赖！</h1> -->
        <p>全国专业化、效率化、系统化酒店外包</p>
        <p style="margin-bottom: 30px">人力资源服务平台，值得您的加入！</p>
        <div class="carousel-text-ul-wrap">
          <img class="carousel-text-ul-QR" src="../assets/1571208580.png" alt="">
          <div class="carousel-text-ul-text">APP下载</div>
        </div>
        <div class="carousel-text-ul-wrap" @click="toHotel()">
          <img class="carousel-text-ul-QR" src="../assets/untitled-20.png" alt="">
          <div class="carousel-text-ul-text">酒店</div>
        </div>
        <div class="carousel-text-ul-wrap" @click="toKeeperauth()">
          <img class="carousel-text-ul-QR" src="../assets/untitled-21.png" alt="">
          <div class="carousel-text-ul-text">人力服务公司</div>
        </div>
        <!-- <div @click="toHotel()">
           <img src="../assets/untitled-20.png" alt="">
           <p>酒店</p>
         </div>
         <div @click="toKeeperauth()">
           <img src="../assets/untitled-21.png" alt="">
           <p>人力服务公司</p>
         </div>-->
      </div>
    </div>
  </div>
</template>

<script>


  export default {
    name: 'Join',
    data() {
      return {
        height: 0,
        cooperateList: [
          {cooperateUrl: require('../assets/hotel1.png')},
          {cooperateUrl: require('../assets/hotel2.png')},
          {cooperateUrl: require('../assets/hotel3.png')},
          {cooperateUrl: require('../assets/logo.png')}
        ]
      }
    },
    mounted () {
      this.height = window.innerHeight - 60;
    },
    methods:{
      toHotel(){
        // this.$router.push({ path:'http://hk.finewe.com.cn/#/hotelauth'});
        window.location.href = 'https://admin.weixinbang.com.cn/#/hotelauth';
      },
      toKeeperauth(){
        window.location.href = 'https://admin.weixinbang.com.cn/#/keeperauth';
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/scss/index.scss';
  @media screen and (min-width:0px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:900px) and (max-width:1200px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width:600px) and (max-width:900px){
    // body {background-color:#f5f5f5;}
    .height{
      height: 800px;
    }
  }
  @media screen and (min-width: 1200px) {
    .height{
      height: calc(100vh - 60px);
    }
  }
  .carousel-wrap {
    width: 100%;
  // height: 1000px;
    /* background-color: #99a9bf; */
    background: url('../assets/untitled-2.png')no-repeat;
    background-size: 100% 100%;
  // display: inline-block;
  @include flex(center);
  }
  .carousel-text {
  /*<!--@include px2rem(width, 600);-->*/
  // @include px2rem(height, 400);
  /*<!--@include px2rem(margin-left, 150);-->*/
  @include flex(center);
  p{
    display: block;
    width: 100%;
  // font-size: 20px;
    @include px2rem(font-size, 64);
    @include px2rem(line-height, 110);
    font-weight: 600;
    color: #ffffff;
  }
  }

  .carousel-text-ul-wrap{
    background: #ff9f41;
    // padding: 20px;
      @include px2rem(padding, 10);
      @include px2rem(margin, 20);
    .carousel-text-ul-QR{
    @include px2rem(width, 150);
    @include px2rem(height, 150);
    }
  .carousel-text-ul-text{
    @include px2rem(margin-top, 10);
    color: #fff;
    @include px2rem(font-size, 20);
    }
    }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    /*line-height: 400px;*/
    margin: 0;
  }

  .carousel-cooperate-list > img {
    width: 25%;
    height: 120px;
    margin: 10px 20px;
  }

  .carousel-text > h1 {
    line-height: 50px;
  }


  .carousel-code img {
    width: 150px;
    height: 150px;
  }

  .carousel-cooperate > h2 {
    line-height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Join.vue